export const createDefaultGpuConfig = () => ({
  gpuProduct: "",
  gpuCount: 1,
  memory: 32,
  nodeCount: 1,
  burstBufferEnabled: false,
});

export const createDefaultCpuConfig = (cpuCores = 32) => ({
  cpuCores,
  memory: 32,
  nodeCount: 1,
});

export const createConfigValidationState = () => ({
  status: "idle",
  canonicalYaml: "",
  validatedYaml: "",
  validationId: "",
  validationExpiresAt: null,
  warnings: [],
});

export const buildConfigValidationState = (validation, validatedYaml) => {
  const hasReceipt = Boolean(
    validation?.valid &&
      validation.canonical_yaml &&
      validation.validation_id &&
      validation.validation_expires_at,
  );

  return {
    status: hasReceipt ? "valid" : "invalid",
    validatedYaml,
    canonicalYaml: hasReceipt ? validation.canonical_yaml : "",
    validationId: hasReceipt ? validation.validation_id : "",
    validationExpiresAt: hasReceipt ? validation.validation_expires_at : null,
    warnings: validation?.warnings || [],
  };
};

export const isConfigValidationCurrent = (validation, yamlText) => {
  const expiresAt = Date.parse(validation.validationExpiresAt || "");
  return (
    validation.status === "valid" &&
    validation.validatedYaml === yamlText &&
    Boolean(validation.canonicalYaml) &&
    Boolean(validation.validationId) &&
    Number.isFinite(expiresAt) &&
    expiresAt > Date.now()
  );
};

export const validationStatusMeta = {
  idle: { label: "Not validated", color: "text.disabled" },
  validating: { label: "Validating", color: "info.main" },
  valid: { label: "Validated", color: "success.main" },
  invalid: { label: "Invalid", color: "error.main" },
};

export const toMessageList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

export const removeMessageAt = (value, index) =>
  toMessageList(value).filter((_, messageIndex) => messageIndex !== index);

export const buildPartialImportMessage = (fileName) =>
  `Loaded editable fields from ${fileName}. Fix errors before submission.`;

export const buildPreviewValidationProps = ({
  primaryError,
  setPrimaryError,
  importError,
  setImportError,
  importSuccess,
  setImportSuccess,
  importWarnings,
  setImportWarnings,
}) => {
  const primaryErrors = toMessageList(primaryError);
  const importErrors = toMessageList(importError);

  return {
    error: primaryErrors.length ? primaryErrors : importErrors,
    onErrorClose: (index) => {
      if (primaryErrors.length) {
        setPrimaryError((prev) => removeMessageAt(prev, index));
      } else {
        setImportError((prev) => removeMessageAt(prev, index));
      }
    },
    success: importSuccess,
    onSuccessClose: () => setImportSuccess(""),
    warnings: toMessageList(importWarnings),
    onWarningClose: (index) =>
      setImportWarnings((prev) => removeMessageAt(prev, index)),
  };
};
